import { memo } from 'react';
import Select from 'react-select';

import { TRUE_OP } from '../../../constants';
import { useControlledSelect } from './hooks/useControlledSelect';
import { useControlledSelectStyles } from './hooks/useControlledSelectStyles';
import { ControlledSelectProps } from './types/ControlledSelectProps';

const ControlledSelectComponent = <IsMulti extends boolean = false>({
  'aria-label': ariaLabel,
  disabled,
  isLoading,
  inputValue,
  isMulti = false,
  onInputChange,
  placeholder,
  searchable = false,
  value,
  options,
  groups,
  onChange,
  name,
  ...props
}: ControlledSelectProps<IsMulti>) => {
  const styles = useControlledSelectStyles(props);
  const { components, handleChange, formatGroupLabel, selectedOption } =
    useControlledSelect({ value, options, groups, onChange, isMulti });

  return (
    <Select
      aria-label={ariaLabel}
      closeMenuOnScroll={false}
      components={components}
      filterOption={inputValue !== undefined ? TRUE_OP : undefined}
      formatGroupLabel={formatGroupLabel}
      inputId={name}
      inputValue={inputValue}
      isDisabled={disabled}
      isLoading={isLoading}
      isMulti={isMulti}
      isSearchable={searchable || inputValue !== undefined}
      menuPortalTarget={document.body}
      menuPosition="fixed"
      name={name}
      onChange={handleChange}
      onInputChange={
        onInputChange
          ? (newInputValue, { action }) => {
              if (action !== 'input-blur' && action !== 'menu-close') {
                onInputChange(newInputValue);
              }
            }
          : undefined
      }
      options={options || groups}
      placeholder={placeholder}
      styles={styles}
      unstyled
      value={selectedOption}
    />
  );
};

export const ControlledSelect = memo(ControlledSelectComponent);
